export const calculateTime = (start: Date, end: Date, value: number) => {
  const totalDuration = end.getTime() - start.getTime()
  const timeOffset = (value / 100) * totalDuration
  return new Date(start.getTime() + timeOffset)
}
